import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { ExternalTestPartnerId } from "@brewbase/db/types";
import { ExternalLabsPage } from "@/features/analytics/external/external-labs-page";

export const Route = createFileRoute("/analytics/external/")({
  validateSearch: z.object({
    tab: z.enum(["to-order", "orders", "history"]).optional(),
    lab: z.coerce.number().int().positive().optional(),
  }),
  component: ExternalRoute,
});

function ExternalRoute() {
  const { tab, lab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ExternalLabsPage
      tab={tab}
      labId={lab as ExternalTestPartnerId | undefined}
      onNavigate={(next) =>
        navigate({
          search: (prev) => ({
            ...prev,
            // Kept as chosen: with no tab the page picks one for the lab
            ...("tab" in next ? { tab: next.tab } : {}),
            ...("lab" in next ? { lab: next.lab } : {}),
          }),
          replace: true,
        })
      }
    />
  );
}
